import gql from "graphql-tag";

export const importPersonsEnrolledInSemester = gql`
    mutation ImportPersonsEnrolledInSemester($data: [ImportPersonInput]) {
        importPersonsEnrolledInSemester(data: $data)
    }
`;
